import { normalize } from 'normalizr'
import { Commit } from 'vuex'

import CreditNote from '@/models/credit-note'

import axios from '@/axios-module'
import { creditNotesSchema, CreditNotesReponse } from '@/schemas/creditNote'

export enum CreditNoteActionTypes {
  LoadByBookingId = '[CreditNotes] LoadByBookingId',
}

export enum CreditNoteMutationTypes {
  LoadStarted = '[Messages] LoadStarted',
  LoadByBookingIdSuccess = '[CreditNotes] LoadByBookingIdSuccess',
  LoadByBookingIdError = '[CreditNotes] LoadByBookingIdError',
}

export interface State {
  creditNoteEntities: {
    [id: number]: CreditNote
  }
  creditNoteIds: number[]
  creditNoteLoaded: boolean
}

const initialState: State = {
  creditNoteEntities: {},
  creditNoteIds: [],
  creditNoteLoaded: false,
}

export default {
  state: initialState,
  getters: {
    getCreditNotesByIds(state: State): (ids: number[]) => CreditNote[] {
      return (ids: number[]) =>
        (ids || []).map((id) => state.creditNoteEntities[id])
    },
  },
  actions: {
    async [CreditNoteActionTypes.LoadByBookingId](
      { commit }: { commit: Commit },
      bookingId: number,
    ) {
      try {
        commit(CreditNoteMutationTypes.LoadStarted)
        const response = await axios.get(
          `customer/bookings/${bookingId}/credit_notes`,
        )
        const normalizedResponse = normalize(response.data, creditNotesSchema)
        normalizedResponse.bookingId = bookingId
        commit(
          CreditNoteMutationTypes.LoadByBookingIdSuccess,
          normalizedResponse,
        )
      } catch {
        commit(CreditNoteMutationTypes.LoadByBookingIdError)
      }
    },
  },
  mutations: {
    [CreditNoteMutationTypes.LoadStarted](state: State) {
      state.creditNoteLoaded = false
    },
    [CreditNoteMutationTypes.LoadByBookingIdSuccess](
      state: State,
      creditNotesResponse: CreditNotesReponse,
    ) {
      state.creditNoteEntities = creditNotesResponse.entities.creditNotes
      state.creditNoteIds = creditNotesResponse.result
      state.creditNoteLoaded = true
    },
  },
}
